<template>
  <!-- begin::Page loader -->
  <div class="page-loader page-loader-logo">
    <img alt="Logo" :src="loaderLogo" width="68" height="56" />
    <div class="spinner mb-10" :class="spinnerClass || 'spinner-primary'"></div>
    <slot></slot>
  </div>
  <!-- end::Page Loader -->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Loader',
  props: {
    spinnerClass: String,
  },
  computed: {
    ...mapGetters(['layoutConfig']),
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo')
    },
  },
}
</script>
